import * as Yup from 'yup'

const getRawValue = (v: any) => (typeof v === 'object' ? v?.value : v)

export const getValidationSchema = () =>
  Yup.object()
    .shape({
      shopCode: Yup.mixed().nullable(),
      shopType: Yup.mixed().nullable(),
      regionId: Yup.mixed().nullable(),
      prodCode: Yup.string().required('Campul este obligatoriu.')
    })
    .test(
      'shopCode-xor-shopType',
      'Completeaza fie Magazin, fie Adaugă regulă produse sensibile.',
      values => {
        const shopCode = !!values?.shopCode
        const shopType = !!values?.shopType
        return (shopCode && !shopType) || (!shopCode && shopType)
      }
    )
    .test('region-required', 'Campul Regiune este obligatoriu.', values => {
      const shopType = getRawValue(values?.shopType)
      if (shopType === 'REGION') {
        return !!values?.regionId
      }
      return true
    })

export const getInitialValues = () => {
  return {
    shopCode: null,
    shopType: null,
    regionId: null,
    prodCode: null
  }
}
